var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6668 20.0002C36.6668 10.8002 29.2002 3.3335 20.0002 3.3335C10.8002 3.3335 3.3335 10.8002 3.3335 20.0002C3.3335 28.0668 9.06683 34.7835 16.6668 36.3335V25.0002H13.3335V20.0002H16.6668V15.8335C16.6668 12.6168 19.2835 10.0002 22.5002 10.0002H26.6668V15.0002H23.3335C22.4168 15.0002 21.6668 15.7502 21.6668 16.6668V20.0002H26.6668V25.0002H21.6668V36.5835C30.0835 35.7502 36.6668 28.6502 36.6668 20.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookYellow);
export default __webpack_public_path__ + "static/media/facebook-yellow.61c74e74dea46f2135f5a72bb4885bd2.svg";
export { ForwardRef as ReactComponent };